import { Component, OnInit, ViewChild, ElementRef,HostListener  } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '../auth.service';
import { LocationService } from '../location.service';
import { NativeGeocoderOptions, NativeGeocoderResult, NativeGeocoder } from '@ionic-native/native-geocoder/ngx';
import { LaunchNavigator, LaunchNavigatorOptions } from '@ionic-native/launch-navigator/ngx';
import { BottomSheet } from '../bottom.sheet';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DomSanitizer } from '@angular/platform-browser';
import { ThumbnailService } from '../thumbnail.service';
import { IonSlide, Platform } from '@ionic/angular';
import { SmsRetriever } from '@ionic-native/sms-retriever/ngx';
import { LocationStrategy } from '@angular/common';
declare var google;
let userLatLng,custLatLng,custLat;
let k=1;
@Component({
  selector: 'app-internal-services',
  templateUrl: './internal-services.component.html',
  styleUrls: ['./internal-services.component.scss'],
})
export class InternalServicesComponent  {
  @ViewChild('map',{static: false}) mapElement: ElementRef;
  serviceID;
  Ind;
  popLoad: boolean = false;
  typePopupCheck:boolean=false;
  cartload: boolean = false;
  orderId;
  fontStyle;
  otherItem;
  pic;
  showDiv:boolean=false;
  showAdd:boolean=true;
  slideOpts={
    loop:false,
    effect: 'slide',
  
    slidesPerView: 4,
    spaceBetween: 8
  }
  numb;
  ProductObj = [];
  itemtypeObj=[];
  showQty;
  items = [];
  cartView:boolean=false;

  spinner:boolean;
  loader:boolean;
  orderItems: any =[];
  id;
  storeObj: any = [];
  filterData: any = [];
  dateFormat;
  url; 
  search;
  serviceDetails: any = [];
  serviceInc:boolean = false;
  servHead:boolean = false;
  packHead:boolean = false;
  redirect:boolean = false;
  typePopup:boolean;
  show:boolean = true;
  squareFeet:boolean=false;
  indService;
  category;
  categoryCode;
  serviceName;
  orderQty = 0;
  modelObj;
  makeObj;
  modelName;
  modelId;
  makeName;
  makeId;
  typeObj;
  typeName;
  typeId;
  orderAmountStr;
  requestId:any=[];
  cateCode;
itemCategoryObj:any=[];
  itemTypeId;
  typeCode;
  region;
  serviceObj:any;
  otherItemPop:boolean;
  showSearch:boolean;
  src:any;
  video:boolean = false;
  cost;
  serviceId;
  dummy;
  amtLoader:boolean;
  otpClicked:boolean;
  typeDoc;
  public smsTextmessage: string = '';
  public appHashString: string = '';
  orderEditQty:any;
  editFlow:boolean;
  backClicked:boolean=false;
  firstLoad:boolean = true;
  firstLoad1:boolean = true;
  mixedBookingValue;
  mixvalue;
  typeConfirmPop:boolean;
  itemname;
  addmixed:any={};
    constructor(   private service: ApiService,protected sanitizer: DomSanitizer,
      public handler: HandlerService,
      public router: Router,
      public translate: TranslateService,
      public thumb:ThumbnailService,
      private launchNavigator: LaunchNavigator,
        private geoCoder:NativeGeocoder,
      public auth: AuthService,  public location: LocationService,   public bottomSheet: MatBottomSheet,public smsRetriever: SmsRetriever,
      private platform: Platform,private locationStrategy: LocationStrategy) {
     
       }
  
  ionViewWillEnter(){
    this.otpClicked = true;
    this.loader = false; 
    this.cartView=false;
    // this.showAdd=true;
    this.typeConfirmPop = false;
    this.orderItems={};
    this.itemTypeId = sessionStorage.getItem('itemTypeId');
    this.dateFormat = this.auth.getDateformat();  
    this.cateCode = sessionStorage.getItem('cateCode') 
    this.region = sessionStorage.getItem('region')
    this.dummy = sessionStorage.getItem('dummyValue')
    this.mixedBookingValue = sessionStorage.getItem('mixedbooking')
    if(sessionStorage.getItem('dummyValue')=='true'){
      this.spinner=false;
      this.loader=false;
      this.cartView=true;
    }else{
     this.spinner=true;  
    }
    if(sessionStorage.getItem('login')){
      this.cartView=true;
    }
    this.url = window.location.href; 
   if(this.url.includes('edit-services')){
    this.cartView = true;
    this.editFlow = true;
    this.id=sessionStorage.getItem('categoryId')
    this.orderId = localStorage.getItem('orderId');
    this.itemname = sessionStorage.getItem('itemname');
    this.getOrderById();
    this.pic = sessionStorage.getItem('tImg');
    this.typeName = sessionStorage.getItem('tName');
    this.showSearch = true; 


   }else{
    // this.spinner = true;
    this.editFlow = false;
    this.id = sessionStorage.getItem('categoryId');
    if(this.cateCode=="CAR" ){
      if( !this.itemTypeId)  {
       this.typePopup = true;
       this.otherItemPop = false;
       this.itemtypeObj=[];
       this.showSearch=true;
       this.getCustMake();
      }
     }else if(this.cateCode!="CAR"){   
       if( !this.itemTypeId)  {
         this.typePopup = false;
         this.showSearch=false;
         this.getitemTypeInCreate();
       }
     }
    
     if(this.cateCode=="CAR"){
       if( this.itemTypeId && this.dummy )  {
        this.typePopup = false;
        this.otherItemPop = false;
        this.showSearch=true;
        this.getCustitemType();
       }
      }else{   
        if( this.itemTypeId && this.dummy )  {
          this.typePopup = false;
          this.otherItemPop = false;
          this.showSearch=false;
          this.getitemTypeInCreate();
        }
      }
    this.itemCategory1();
   }
  }

  playVideo(data){
    if(data.docId != undefined){
      this.video = true;
      this.service.getAdImage(data.docId).subscribe((res:any)=>{
        this.src= this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
      },
      err=>{
        this.handler.err(err);
      })
    }else{
      this.handler.res("No Video Found")
    }  
  }

  getOrderById(){
    this.service.getOrderByIdOri(this.orderId).subscribe((res:any) => {
      if (res) {
        localStorage.setItem('shopId',res.orgId)
        this.orderItems = res;
        this.id=res.categoryId;
        this.orderEditQty = res.itemOrders;
        this.cartView = true;
        // if(this.cateCode=="CAR"){
        //   this.itemTypeId = this.orderItems.itemOrders[0].itemTypeId;
        //   this.selectItem();
        // }else{
          this.itemTypeId = sessionStorage.getItem('itemTypeEdit');
          this.selectItem();
        if(this.cateCode!="CAR"){
          this.getitemTypeInCreate();
          this.showSearch = false;
        }
      
        if(this.cateCode =="CAR" && sessionStorage.getItem('tDoc')){
          this.getDoc(sessionStorage.getItem('tDoc'))
        }
        
      }
           if(this.orderItems.delRegion != sessionStorage.getItem('region')){
      this.UpdateService();
    }
    },
      err => {
             this.handler.err(err.error)
      })
  }



  UpdateService(){
    this.loader = true; 
    Object.assign(this.orderItems,{"type": 1,
    "delDoorNbr": this.location.houseNbr,
    "delStreet": this.location.street,
    "delCity": this.location.cityId,
    "delState":this.location.stateId,
    "region":this.region,
    // "lat":this.location.lat,
    // "lon":this.location.lon,
    // "latitude":this.location.latitude,
    // "longtitude":this.location.longtitude,
    "delRegion":this.region,
    })
    if(sessionStorage.getItem('cateCode')=="CAR"){
      Object.assign(this.orderItems,{"itemTypeId": sessionStorage.getItem('itemTypeId')})
    }
    if(this.location.lat){
      Object.assign(this.orderItems,{lat:this.location.lat})
    }else{
     Object.assign(this.orderItems,{lat:localStorage.getItem('lat')})
    }
    if(this.location.lon){
      Object.assign(this.orderItems,{lon:this.location.lon})
    }else{
      Object.assign(this.orderItems,{lon:localStorage.getItem('lon')})
    }  
    Object.assign(this.orderItems,{cnvcChargeApplied:true})
 this.service.updateOrder(this.orderId,this.orderItems).subscribe((res:any) =>{   
   sessionStorage.setItem('region',this.region);
   this.handler.res('Cost Updated Successfully , based on region and item type!!')
   this.getOrderById();
   this.typePopupCheck=false;
   this.loader = false;
 },err => {
   this.loader = false;
   this.handler.err(err)
 })
}

checkService(){
if(this.orderId){
  this.UpdateService();
}else{
  this.typePopupCheck=false;
}
}

  closeVideo(){
    this.video = false;
    this.src = undefined;
  }

  getItemType(){
    this.service.getItemType().subscribe((res: any)=>{
      this.itemCategoryObj= res;  
    this.itemCategoryObj.map(res1=>{
      if(res1.id==this.itemTypeId){
        this.typeName=res1.name;
        this.typeCode =res1.code;
        this.pic = res1.img;
      }
    })
    })
  }

  
getCustMake(){
  this.modelName = "" ;
  this.typeName ="";
  this.itemTypeId = "";
  this.popLoad=true;
  this.service.getMake(this.id).subscribe((res:any)=>{
    if(res){
      this.makeObj = res;
      this.popLoad=false;
    }
  })
}

getCustModel(){
  this.popLoad=true;
  this.service.getModel(this.id,this.makeId).subscribe((res:any)=>{
    if(res){
      this.modelObj = res;   
      this.popLoad=false;
    }  else{
      this.popLoad=false;
      this.handler.res('Model not available for this make!!! Please choose equivalent make')
    }
  },
  err=>{
    this.popLoad=false;
    this.handler.err(err);

  })
}


getCustitemType(){
  this.popLoad=true;
  if(this.dummy){
    this.makeId=sessionStorage.getItem('makeId');
    this.modelId=sessionStorage.getItem('modelId')
    this.service.getCustItemType(this.id,this.makeId,this.modelId).subscribe((res:any)=>{
      if(res){
      this.typeObj = res;
      this.typeObj.map(res1=>{
        this.itemTypeId = res1.itemTypes[0].id;
        this.typeName=res1.itemTypes[0].name;
        this.typeCode =res1.itemTypes[0].code;
        if(res1.itemTypes[0].docId){
          this.getDoc(res1.itemTypes[0].docId);
          this.typeDoc=res1.itemTypes[0].docId;
          sessionStorage.setItem('tDoc',this.typeDoc);  
        }
        sessionStorage.setItem('tName',this.typeName);
        sessionStorage.setItem('tImg',this.pic);
      })
       sessionStorage.setItem('itemTypeId',this.itemTypeId)
       sessionStorage.setItem('itemTypeEdit',this.itemTypeId)  
       this.popLoad=false;
    }else{
      this.popLoad=false;
      this.handler.res('Item Type not available for this make and model!!! Please choose equivalent make')
    } 
  },
  err=>{
    this.popLoad=false;
    this.handler.err(err);     
    })  
  }else{
    this.service.getCustItemType(this.id,this.makeId,this.modelId).subscribe((res:any)=>{
      if(res){
      this.typeObj = res;
      this.typeObj.map(res1=>{
        this.itemTypeId = res1.itemTypes[0].id;
        this.typeName=res1.itemTypes[0].name;
        this.typeCode =res1.itemTypes[0].code;
        if(res1.itemTypes[0].docId){
          this.getDoc(res1.itemTypes[0].docId);
          this.typeDoc=res1.itemTypes[0].docId;
          sessionStorage.setItem('tDoc',this.typeDoc);  
        }
        sessionStorage.setItem('tName',this.typeName);
        sessionStorage.setItem('tImg',this.pic);
      })
       sessionStorage.setItem('itemTypeId',this.itemTypeId) 
       sessionStorage.setItem('itemTypeEdit',this.itemTypeId) 
       sessionStorage.setItem('itemItpeName',this.typeName)
       this.popLoad =false;
      }else{
        this.popLoad=false;
        this.handler.res('Item Type not available for this make and model!!! Please choose equivalent make')
      } 
    },
    err=>{
      this.popLoad=false;
      this.handler.err(err);          
    })
  }

}

detailPopupClose(){
  this.typePopupCheck=false;
  this.typeName=sessionStorage.getItem('itemItpeName')

}

getDoc(data){
  this.loader=false;
  this.spinner=false;
  this.service.getAdImage(data).subscribe(res => {
    this.pic = this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(res));
  })
}


back(){
  if(this.auth.loged()){
    this.router.navigate(['/bookservice1'])
  }else{
    this.router.navigate(['/bookservice'])
  }
}

getitemTypeInCreate(){
  if(sessionStorage.getItem('dummyValue')=='true'){
    this.spinner=false;
    this.loader=false;
    this.cartView=true;
  }else{
   this.spinner=true;  
  }
  // this.spinner=true;
  this.service.getItemTypeByCategory(this.id).subscribe((res: any)=>{
    if(res){
      this.itemtypeObj= res;
      this.itemtypeObj.map(dat1=>{
        Object.assign(dat1,{highlight:false})
      }) 
      if(this.url.includes('subservice1') || this.url.includes('subservice')){
        if(this.itemtypeObj.length >= 4){
          this.otherItemPop = true
        }else{
          this.otherItem = this.itemtypeObj[0];
          Object.assign(this.otherItem,{highlight:true})
          this.routeToItems(this.otherItem) 
        }
      }
      // this.itemtypeObj = this.itemtypeObj.filter(res=>{return res.itemCategory==this.id})   
   
      this.itemtypeObj.map(dat2=>{
        if(dat2.docId){
          this.thumb.getThumbIcon1(dat2);
        }
      })   
      this.itemTypeId = sessionStorage.getItem('itemTypeEdit')
      if(this.dummy){
        this.itemtypeObj.map(res=>{
          if(res.id==this.itemTypeId)
             res.highlight==true;
        }) 
      }
      this.firstLoad = true;
      if(this.url.includes('edit-services')){
        if(this.firstLoad){
          this.itemtypeObj.map(res1=>{
            if(res1.id==sessionStorage.getItem('itemTypeEdit')){
              Object.assign(res1,{highlight:true})
            }      
          }) 
          this.firstLoad = false;
          this.itemtypeObj.sort(function(a, b) {
            return b.highlight - a.highlight 
          })
        }
      }
     this.spinner=false;
     if(this.url.includes('subservice1') || this.url.includes('subservice')){
       this.loader = false;
     }
    }else{
      if(this.url.includes('subservice1') || this.url.includes('subservice')){
        this.loader = false;
      }
      this.spinner=false;
       }
  }, err=>{
    this.spinner = false;
    this.handler.err(err)  
  })
}

getServicebyId(){
  this.service.getItemById(this.serviceID).subscribe((res: any) => {
    this.serviceObj = res;
    this.itemTypeId = res.subCost[0].itemTypeId;

    if(!this.orderId){    
      this.createOrder(); 
    } else{
      this.updateOrder();
    } 
  })
}

getServicebyId1(){
  this.service.getItemById(this.serviceID).subscribe((res: any) => {
    this.serviceObj = res;
    this.itemTypeId = res.subCost[0].itemTypeId;
  
    this.updateOrderItem()
  })
}

openBottomSheet1(): void {
  // this.makeObj.map(res=>{
  //   Object.assign(res,{makeValue:true})
  // })
  const dialogRef = this.bottomSheet.open(BottomSheet,{
    data: this.makeObj,
  });
  dialogRef.afterDismissed().subscribe((res:any) => {
  this.makeName = res.name;
  this.makeId = res.id; 
  this.modelName = "" ;
  this.typeName ="";
  this.itemTypeId = "";
  this.modelObj="";
      if(this.makeName){
        this.getCustModel();
      }   
      sessionStorage.setItem('make', this.makeName);
      sessionStorage.setItem('makeId', this.makeId);
  });
}

openBottomSheet2(): void {
  // this.modelObj.map(res=>{
  //   Object.assign(res,{makeValue:false})
  // })
 const dialogRef = this.bottomSheet.open(BottomSheet,{
   data: this.modelObj,
 });
 dialogRef.afterDismissed().subscribe((res:any) => {
   if(res){
     this.modelName = res.name;
     this.modelId = res.id; 
     this.typeName ="";
     this.itemTypeId = "";
     if(this.modelName){
      this.getCustitemType();
    }             
   }
   sessionStorage.setItem('model', this.modelName);
   sessionStorage.setItem('modelId', this.modelId);
 });

}



  getService(){ 
    this.loader = true; 
    this.Ind=false; 
    this.showAdd=false;
    this.showDiv=false;
    this.service.getAllItemsByCategory(this.id,this.Ind).subscribe((res:any)=>{
     if(res){
     this.storeObj = res;
     this.showDiv=true;
     this.showAdd=true;
     this.filterData = res;
     this.storeObj.map(res1=>{
      Object.assign(res1, { select: false, qty: 0, showQty: 0,success:false,amtLoader:true,mixedbook:this.mixedBookingValue,offerCost:""}) 
     }) 
    this.storeObj = this.storeObj.filter(res=>{return res.packageInd == false && res.itemCategoryId==this.id})
    if(this.url.includes('edit-services')){
      this.storeObj.map(dat=>{
        this.orderEditQty.map(dat1=>{
          if(dat.id == dat1.itemId){
            dat.qty = dat1.qty;
            dat.showQty = dat1.qty;
            this.showDiv = true;
          }
        })
      })
    }
    if(this.url.includes('edit-services')){
      this.getOrder(this.orderId);
    }
  
    if(this.itemTypeId && this.cateCode=='CAR'){ 
      this.storeObj.map(dat=>{
        this.getCost(dat);
       })
    }else {
        if(this.url.includes('subservice1') && this.orderId){
          this.getOrder(this.orderId);
        }
        this.storeObj.map(dat1=>{
          if(dat1.subCost){
            dat1.subCost.map(dat2=>{
              if(dat2.itemTypeId==this.itemTypeId){
                dat1.success = true;
              }
            })
          }
        })   
      
        this.storeObj = this.storeObj.filter(dat1=>{return dat1.success})
      
        this.storeObj.map(dat=>{       
          this.getCost(dat);
         })
       this.storeObj.map(dat3=>{
        if(dat3.imageId){   
          this.thumb.getThumbIcon(dat3)
        }
       })
    
       this.loader = false;  
    } 
    
    this.storeObj.map(dat3=>{
      if(dat3.imageId){   
        this.thumb.getThumbIcon(dat3)
      }
    })
    this.loader=false;
  }
     this.loader = false; 
   },err =>{
     this.handler.err(err)
     this.loader = false;    
   })  
     
  }

  getCost(data){
    var data1={
      "itemTypeId": this.itemTypeId,
      "region": this.region,
      "serviceId":data.id
    }
    this.service.getCost(data1).subscribe((res:any)=>{
      if(res!=null){
        data.cost= res[0].cost;
        data.offerCost=res[0].offerCost;        
      }else{
        data.cost = data.dfltCost;
        data.offerCost=res[0].offerCost; 
        Object.assign(data,{show:true})        
      } 
      data.amtLoader=false;       
    }, err => {    
      this.handler.err(err);
    }) 
    
  }
  
  route(){ 
      if(this.cateCode=="CAR" ){
        sessionStorage.setItem('make', this.makeName)
        sessionStorage.setItem('itemTypeId',this.itemTypeId)
        sessionStorage.setItem('typeCode',this.typeCode)
        sessionStorage.setItem('model', this.modelName)  
      }else{
        sessionStorage.setItem('itemTypeId',this.itemTypeId)
      }
      this.router.navigate(['/req-booking'])   
      
    } 

    ionViewWillLeave(){
      this.serviceInc = false;
      this.redirect = false;
      this.otpClicked = true;
      sessionStorage.removeItem('login')
      this.orderId = "";
      sessionStorage.setItem('region',this.region)
      this.itemtypeObj=[];
      sessionStorage.setItem('orderValue',this.orderItems.orderAmountStr)
      sessionStorage.setItem('orderLen',this.orderItems.itemOrders.length)
      if(this.orderItems.orderAmountStr==0 && this.orderItems.itemOrders.length==0){
        localStorage.removeItem('orderId');
        localStorage.removeItem('cateId')
      }
    }

    getDetails(data){
      this.indService = data;
      if(!this.auth.loged()){
        this.serviceInc = true;
        this.itemCategory(); 
      }else{
        this.redirect = true;
        this.itemCategory(); 
        setTimeout(() => {
          this.route();
        },2000); 
      
      }
       
    }

    itemCategory(){
      this.service.getOrgCategory().subscribe(res=>{
        this.category = res;   
        if (this.category.length > 0)  {
          this.category.map(res1 => {
            if (res1.id == this.indService.itemCategoryId ) {           
              this.categoryCode = res1.code;                                                                   
            }
            }) 
      }
       }) 
    }

    itemCategory1(){
      this.service.getOrgCategory().subscribe(res=>{
        this.category = res; 
        if (this.category.length > 0) {
          this.category.map(res1 => {
            if (res1.id ==   this.id ) {           
              this.categoryCode = res1.code;                                                                      
            }
            if(this.categoryCode=="PSC" || this.categoryCode=="HC"){
              this.show= false;
            }
            }) 
     
      }
      if( this.dummy == "true"){
        this.getService();
        this.loader=false;
        this.spinner=false;
      } 
       })
        }


    getHashCode() {
      this.otpClicked = false;
      if(this.platform.is('android')){
        this.smsRetriever.getAppHash()
        .then((res: any) => {
          this.appHashString = res;
          this.signIn();
        })
        .catch((error: any) => {
          this.signIn();
        });
      }else{
        this.signIn();
      }
    }
          

    signIn(){
      if(this.numb.length == 10){
        sessionStorage.setItem('id',this.id)  
        var post={
          "contactNbrMob":'+91'+ this.numb,
          "orgCode":'YB',
          "paless": true,
          "userType":1,
          "roles": ['CUST'], 
          "appId":14,
          "addresses":[
            {
              "cityId": this.location.cityId,
              "stateId": this.location.stateId,
              "regionId":this.location.regionId,
              "street":this.location.street,
              "zipcode":this.location.zipcode,
              "lat": this.location.lat,
              "lon": this.location.lon,
              // "":this.location.latitude,
              // "longtitude":this.location.longtitude,
              "type": 2,
              "orgId":790
            }
          ]
        }  
        if(this.platform.is('android')){
          Object.assign(post,{ "hashSms" : this.appHashString})
        }
        this.service.customerLogin(post).subscribe((res:any)=>{
          if(res){
          if(this.platform.is('android')){
            Object.assign(res,{ "hashSms" : this.appHashString})
          }
          sessionStorage.setItem('contactNbrMob',this.numb)
          window['mock'] = res;  
          this.handler.loginRes(res); 
           this.serviceInc=false;
           this.numb="";
          this.router.navigate(['/validateForOrder'])
        }
        },err => {
          this.handler.err(err);
          this.otpClicked = true;
        })
      }else{
        this.handler.phNumError("Please enter valid mobile number")
        this.otpClicked = true;
      }
    }

    logIn(){ 
      sessionStorage.setItem('id',this.id)    
      this.router.navigate(['/customer-reg'])    
      } 

     

      addQuantity(data) {
        this.showDiv=false;  
        if(!this.auth.loged()){
          this.serviceInc=true;
        } else{
          this.storeObj.map(res => {
            if (res != data)
              res.select = false;
            else
              res.select = true
          })      
            data.showQty = data.showQty + 1;
            if(data.showQty > 0){
              this.cartView = true;
            }
          if(!this.orderId){       
            this.createOrder(); 
          } else{
            if(this.mixvalue == data.subCost[0].itemTypeId || (data.mixedbook=='true' && this.mixvalue != data.subCost[0].itemTypeId)){
              this.updateOrder();
            }else{
              data.showQty=0
              this.showDiv=true;
              this.typeConfirmPop=true;
              this.addmixed=data;
            }
          }  
        
        }  
 
    }
    addMixedvalue(data){
     this.showDiv=false;  
     if(!this.auth.loged()){
       this.serviceInc=true;
     } else{
       this.storeObj.map(res => {
         if (res != data)
           res.select = false;
         else
           res.select = true
       })      
         data.showQty = data.showQty + 1;
         if(data.showQty > 0){
           this.cartView = true;
         }
       if(!this.orderId){       
         this.createOrder(); 
       }
     }  
    }

      decQuantity(data) { 
        this.showDiv=false;  
        this.storeObj.map(res => {
          if (res != data)
            res.select = false;
          else
            res.select = true
        })
           if (data.showQty == 0)
            data.showQty = data.showQty;
          else {
            data.showQty = data.showQty - 1;
            this.updateOrderItem()
          }
      }
      createOrder() {
        this.cartload = true;
        this.showAdd = false;
        let item = this.storeObj.find(res => res.showQty != 0 && res.select);
      
        item.qty = 1;
        let postData = { 
          "customerId":localStorage.getItem('currentUserId'),
          "orgId":localStorage.getItem('organizationId'),  
          "categoryId":this.id,
          "cnvcChargeApplied":true, 
          "delDoorNbr": this.location.houseNbr,
          "delStreet": this.location.street,
          "delCity": this.location.cityId,
          "delState":this.location.stateId,
          "region":this.region,
          "delRegion":this.region,
          // "lat":this.location.lat,
          // "lon":this.location.lon,
          // "latitude":this.location.latitude,
          // "longtitude":this.location.longtitude,
          "itemTypeId":this.itemTypeId,
          "status": 1,
          "paymtStatus": 1,
          "vendorPaymentStatus":1,
          "paymtMode": 1,
          "orderType" : 1,
          "orderItems" :[
              {
                  "id" : item.id,
                  "qty": item.qty,
                  "billPostVisit":item.billPostVisit
              }
          ],
          "providerServiceId" : item.id      
        }
         if(this.location.lat){
           Object.assign(postData,{lat:this.location.lat})
         }else{
          Object.assign(postData,{lat:localStorage.getItem('lat')})
         }
         if(this.location.lon){
           Object.assign(postData,{lon:this.location.lon})
         }else{
           Object.assign(postData,{lon:localStorage.getItem('lon')})
         }  
        this.service.placeOrder(postData).subscribe((res: any) => {
          if(res){
            this.orderId = res.id;
            localStorage.setItem("orderId",res.id);
            localStorage.setItem("UpdatedOrderId",res.id);
            this.cartload = false;
            this.orderItems = res;  
            this.mixvalue =res.itemTypeId;
            this.itemtypeObj.map(dat2=>{
              if(dat2.id == this.mixvalue){
                this.itemname=dat2.name.toUpperCase();
                sessionStorage.setItem('itemname',this.itemname)
              }
            })
            // if (this.orderItems.items) {
            //   this.storeObj.map(dat => {
            //     this.orderItems.storeObj.map(dat1 => {
            //       if (dat.id == dat1.id)
            //         dat.showQty = dat1.qty;
            //     })
            //   })
            // }
            if(this.orderId){
              this.getOrder(this.orderId);
            }
            this.showDiv=true;
            this.showAdd=true;
          }
       
        },
          err => {
            this.handler.err(err);
                this.cartload = false;  
          })
      }

      getOrder(id) {
        this.showAdd=false;
        this.showDiv=false;
        this.service.getOrderByIdOri(id).subscribe((res: any) => {
          this.cartload = false;
          this.showAdd=true;
          this.showDiv=true;
          
          this.orderItems = res;      
          if (this.orderItems.itemOrders) {
            this.storeObj.map(dat => {
              this.orderItems.itemOrders.map(dat1 => {
                if (dat.id == dat1.itemId)
                  dat.showQty = dat1.qty;
              
              })
            })
          }
          
        }, err => {
          this.cartload = false;
          this.handler.err(err)
           })
      }
      updateOrder() {
        this.showDiv=false;  
        this.showAdd=false;
        let item;
        item = this.storeObj.find(dat => dat.showQty != -1 && dat.select);      
          item.qty = 1;
        let products = {      
          "orderItems" :[
            {
                "id" : item.id,
                "qty" :item.qty,
                "billPostVisit":item.billPostVisit
            }
        ],
        providerServiceId:item.id,
          region:this.region, 
          orderType : 1,
          itemTypeId:this.itemTypeId,
          cnvcChargeApplied:true,  
        }
        this.cartload = true;
        this.service.orderItemPost(this.orderId, item.id, products).subscribe((res:any) => {
          if(res){        
            this.cartload = false;
            this.orderItems = res;        
            // if (this.orderItems.items) {
            //   this.storeObj.map(dat => {
            //     this.orderItems.storeObj.map(dat1 => {
            //       if (dat.id == dat1.id)
            //         dat.showQty = dat1.qty;
            //     })
            //   })
            // }
            this.showDiv=true;
            this.showAdd=true;
          }
          if(this.orderId){
            this.getOrder(this.orderId);
          }
          
        },
          err => {
            this.cartload = false;
                  this.handler.err(err)
          })
      }

      async updateOrderItem(){
        let item;
        item = this.storeObj.find(dat => dat.showQty != -1 && dat.select);
        // item.qty = item.showQty;
        item.qty = 1;
        let products = {      
          "orderItems" :[
            {
                "id" : item.id,
                "qty" :item.qty,
                "billPostVisit":item.billPostVisit
            }
        ],
        providerServiceId:item.id,
          region:this.region, 
          orderType : 1,
          itemTypeId:this.itemTypeId,
          cnvcChargeApplied:true, 
         }  
          this.cartload=true;
          this.service.updateOrderItem(this.orderId, item.id, products).subscribe(res => {
            if(res){
              this.cartload = false;
              this.showDiv=true;
              this.showAdd=true;
              this.orderItems = res;          
              // if (this.orderItems.items) {
              //   this.storeObj.map(dat => {
              //     this.orderItems.storeObj.map(dat1 => {
              //       if (dat.id == dat1.id)
              //         dat.showQty = dat1.qty;
              //     })
              //   })
              // }
            }
            if(this.orderId){
              this.getOrder(this.orderId);
            }
           
          },
            err => {
              this.cartload = false;
                   this.handler.err(err)
            })
        }

     selectItem(){
           this.typePopup= false;  
           this.getService();  
     }

     

     routeToReq(){
       if(this.orderId && (this.orderItems.orderAmountStr>0 || this.orderItems.itemOrders.length>0)){
        this.redirect = true;        
        setTimeout(() => {
           this.route();
         },2000); 
       }    
     }

     routeToItems(item){
      this.editFlow = false;
      this.itemtypeObj.map(res=>{
        if(res.id == item.id){
          res.highlight = true;
        }else{
          res.highlight = false;
        }
      })
      this.otherItemPop=false;
      this.itemTypeId=item.id;
      sessionStorage.setItem('itemTypeId',this.itemTypeId);
      sessionStorage.setItem('itemTypeEdit',this.itemTypeId);
      sessionStorage.setItem('itemCatEdit',item.itemCategory);
      // this.storeObj = this.filterData.filter(res=>{ return res.subCost[0].itemTypeId==item.id}) ;
      this.itemtypeObj.sort(function(a, b) {
        return b.highlight - a.highlight 
      })
      this.getService();
     }


     closePop(){
      this.serviceInc=false;
      this.numb="";
    }


    typeUpdate(){
      this.typePopupCheck=true;
      this.makeName="";
      this.makeId="";
      this.getCustMake();
    }
    clear(){
      this.orderId=''
      localStorage.removeItem("orderId");
      localStorage.removeItem("UpdatedOrderId");
      this.orderItems=[];
      this.typeConfirmPop=false;
      if(!this.typeConfirmPop){
        this.addMixedvalue(this.addmixed)
      }
    } 
    Stay(){
      this.typeConfirmPop = false;
    }

      }